import * as React from 'react';
import { Props, propTypes } from './props';
import { getCleanExpiryDate } from 'helpers/date-helper';

export default class DateCellRenderer extends React.Component<Props> {
  static propTypes = propTypes;

  render() {
    return (
      <span>{getCleanExpiryDate(this.props.value)}</span>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/user-grid/cell/renderers/date/component.tsx